import React from "react";
import LeaveSettingsButton from "./LeaveSettings";
import "./LeaveWorkspaceHeader.css";

export default function LeaveWorkspaceHeader({ year, period, refreshing, onRefresh, onApply }) {
  const periodLabel = period ? `${period.startsOn.slice(0, 4)}${period.endsOn.slice(0, 4) !== period.startsOn.slice(0, 4) ? `–${period.endsOn.slice(2, 4)}` : ""}` : year;
  return <header className="se-lwh">
    <div className="se-lwh-title"><span>PEOPLE · LEAVE</span><h1>Leave Management</h1></div>
    <div className="se-lwh-actions">
      <div className="se-lwh-period"><span>{period ? "LEAVE PERIOD" : "YEAR"}</span><strong>{periodLabel}</strong></div>
      <button type="button" className="se-lwh-button" onClick={onRefresh} disabled={refreshing}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M20 7v5h-5M19 12a7 7 0 1 1-2-5l3 3" /></svg>{refreshing ? "Refreshing…" : "Refresh"}</button>
      <LeaveSettingsButton className="se-lwh-button" onChanged={onRefresh} />
      <button type="button" className="se-lwh-button se-lwh-apply" onClick={onApply}><span aria-hidden="true">＋</span> Apply leave</button>
    </div>
  </header>;
}
